export const leadSearchKeys = {
	all: ['leadSearch'],
	search: (q) => ['leadSearch', 'search', q],
};

export const leadSearchMutationKeys = {
	position: ['leadSearch', 'position'],
};
